import React from 'react';
import { Popover } from 'antd';
import { HtmlContent } from '@client/utils/html_content';

/**
 * Component that truncates text and shows full text in popover on hover
 * @param {Object} props
 * @param {string} props.text - The text to display
 * @param {number} [props.maxLength=35] - Maximum length before truncation
 * @param {string} [props.suffix="..."] - Suffix to show when truncated
 * @param {Object} [props.popoverProps] - Additional props for Popover
 * @param {Object} [props.textProps] - Additional props for text span
 * @returns {JSX.Element}
 */
const TruncatedText = ({
  text,
  maxLength = 35,
  suffix = '...',
  popoverProps = {},
  textProps = {},
  ...props
}) => {
  if (!text) return <span {...textProps} {...props}></span>;

  const textString = String(text);
  const isLong = textString.length > maxLength;
  const displayText = isLong
    ? textString.substring(0, maxLength) + suffix
    : textString;

  if (!isLong) {
    return (
      <span {...textProps} {...props}>
        <HtmlContent html={textString} />
      </span>
    );
  }

  return (
    <Popover
      content={
        <div style={{ maxWidth: 300, wordWrap: 'break-word' }}>
          <HtmlContent html={textString} />
        </div>
      }
      title={null}
      trigger="hover"
      placement="top"
      {...popoverProps}
    >
      <span
        style={{
          cursor: 'help',
          borderBottom: '1px dotted #ccc',
          ...textProps.style,
        }}
        {...textProps}
        {...props}
      >
        <HtmlContent html={displayText} />
      </span>
    </Popover>
  );
};

export default TruncatedText;
